import { withStyles } from "@material-ui/core/styles";
import React from "react";

import PageCard from "../../General/PageCard";

const styles = {
  individualLoadedContainer: {
    height: 180,
    display: "flex",
    justifyContent: "space-between",
    paddingLeft: 24,
    paddingRight: 24,
    paddingTop: 24
  },
  emptyStateImg: {
    width: 120,
    height: 100
  },
  individualLoadedTextContainer: {
    paddingLeft: 24
  }
};

function LoggedInContent({ title, classes }) {
  return (
    <PageCard title={title} renderFooter={false}>
      <div className={classes.individualLoadedContainer}>
        <img
          className={classes.emptyStateImg}
          src="https://recruitifi-public.s3.amazonaws.com/empty_search.png"
          alt="Empty State"
        />
        <div className={classes.individualLoadedTextContainer}>
          <h5>Looking for something?</h5>
          <p className="subtitle-1">
            You must sign out of your account before you can register a new one!
          </p>
        </div>
      </div>
    </PageCard>
  );
}

export default withStyles(styles)(LoggedInContent);
